import { render } from "./AvatarTabletFormComponent.vue?vue&type=template&id=501a8b27"
import script from "./AvatarTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./AvatarTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__